import { getString } from 'shared-base';

export const currentIds: ICurrentIds = {
  projectId: getString('projectId'),
  modelId: getString('modelId'),
  generatorId: getString('generatorId'),
  keyframeId: getString('keyframeId'),
  materialCategoryId: getString('materialCategoryId') ?? 'all',
  packId: 1,
  wackModeId: 'taper',
  slotId: 0,
  randomId: 0,
  goldenId: '',
};
